import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import Chart from '../../Chart/Chart';
import ParetoChart from "../../Chart/ParetoChart";
import {authContext} from '../../Context/Authentication/authContext';

import {baseURL} from '../../config';
import {FormControl, InputLabel, MenuItem} from '@mui/material';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import {generateChartData} from '../../Helpers/helpers'

const twoOption = [
  {
    leftKey: 'totalUnits',
    leftTitle: 'Total Units',
    rightKey: 'totalValue',
    rightTitle: 'Total Valuation ($)',
    name: 'totalUnitVsTotalValuation'
  },
  {
    leftKey: 'oneUnit',
    leftTitle: 'One Unit',
    rightKey: 'oneUnitValue',
    rightTitle: 'One Unit Valuation ($)',
    name: 'oneUnitVsOneUnitValuation'
  },
  {
    leftKey: 'twoUnits',
    leftTitle: 'Two Units',
    rightKey: 'twoUnitsValue',
    rightTitle: 'Two Units Valuation ($)',
    name: 'twoUnitsVsTwoUnitsValuation'
  },
  {
    leftKey: 'threeFourUnits',
    leftTitle: 'Three To Four Units',
    rightKey: 'threeFourUnitsValue',
    rightTitle: 'Three To Four Units Valuation ($)',
    name: 'threeUnitsVsThreeUnitsValuation'
  },
  {
    leftKey: 'moreThanFiveUnits',
    leftTitle: 'More Than Five Units',
    rightKey: 'moreThanFiveUnitsValue',
    rightTitle: 'More Than Five Units Valuation ($)',
    name: 'fiveUnitsVsFiveUnitsValuation'
  }
]

const TITLES = {
  totalBuildings: 'Total Buildings',
  totalUnits: 'Total Units',
  totalValue: 'Total Valuation ($)',
  oneUnit: 'One Bedroom',
  oneUnitValue: 'One Bedroom Valuation ($)',
  twoUnits: 'Two Units',
  twoUnitsValue: 'Two Units Valuation ($)',
  threeFourUnits: 'Three to Four Units',
  threeFourUnitsValue: 'Three to Four Units Valuation ($)',
  moreThanFiveUnits: 'More Than Five Units',
  moreThanFiveUnitsValue: 'More Than Five Units Valuation ($)',
}

const findVsOption = (option: any) => {
  return twoOption.find((t: any) => t.name === option)
}

const renderChart = (data: any, originalResp: any, counties: any, option: any) => {
  const info = findVsOption(option)
  if (info) {
    if (counties.length === 1) {
      const data = originalResp[counties[0]]
      return <ParetoChart
        chartData={data}
        city={counties[0]}
        info={info}
      />
    } else {
      return <div className='daysOnMarket-main__chartContainer__noData'>
        Select only one city at a time to see this chart.
      </div>
    }
  } else {
    return <Chart
      chartData={data}
      // @ts-ignore
      title={TITLES[option]}
      city={counties.sort()}
    />
  }
}

const getNoDataText = (option: any) => {
  return option.indexOf('Vs') ? '': 'Permits'
}


const Permits = () => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [apiResponse, setApiResponse]: any = useState([]);
  const [option, setOption]: any = useState('totalBuildings')

  useEffect(() => {
    getPermits();
  }, [state.filters.years, state.filters.county]);

  const handleTypeChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string
    setOption(value)
    const resp = generateChartData(apiResponse, value)
    setChartData(resp)
  };

  const getPermits = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const county = JSON.stringify(state.filters.county)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getBuildingPermitsCounty?state=${state.filters.state}&county=${county}&startYear=${start}&endYear=${end}`
      );
      const resp = response.data?.cube
      setApiResponse(resp)
      const data = generateChartData(resp, option);
      setChartData(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  // @ts-ignore
  return (
    <div className='population-main'>
      <FormControl sx={{m: 1}} fullWidth variant='standard'>
        <InputLabel shrink id='demo-simple-select-label'>
          Select Permit Type
        </InputLabel>
        <Select
          value={option}
          label='Select type'
          onChange={handleTypeChange}
          size='small'
        >
          <MenuItem value={'totalBuildings'}>Total Buildings</MenuItem>
          <MenuItem value={'totalUnits'}>Total Units</MenuItem>
          <MenuItem value={'totalValue'}>Total Valuation ($)</MenuItem>
          <MenuItem value={'oneUnit'}>One Unit</MenuItem>
          <MenuItem value={'oneUnitValue'}>One Unit Valuation ($)</MenuItem>
          <MenuItem value={'twoUnits'}>Two Units</MenuItem>
          <MenuItem value={'twoUnitsValue'}>Two Units Valuation ($)</MenuItem>
          <MenuItem value={'threeFourUnits'}>Three To Four Units</MenuItem>
          <MenuItem value={'threeFourUnitsValue'}>Three To Four Units Valuation ($)</MenuItem>
          <MenuItem value={'moreThanFiveUnits'}>More Than Five Units</MenuItem>
          <MenuItem value={'moreThanFiveUnitsValue'}>More Than Five Units Valuation ($)</MenuItem>
          <MenuItem value={'totalUnitVsTotalValuation'}>Total Units Vs Total Valuation ($)</MenuItem>
          <MenuItem value={'oneUnitVsOneUnitValuation'}>One Unit Vs One Unit Valuation ($)</MenuItem>
          <MenuItem value={'twoUnitsVsTwoUnitsValuation'}>Two Units Vs Two Units Valuation ($)</MenuItem>
          <MenuItem value={'threeUnitsVsThreeUnitsValuation'}>Three To Four Units Vs Three To Four Units Valuation ($)</MenuItem>
          <MenuItem value={'fiveUnitsVsFiveUnitsValuation'}>More Than Five Units Vs More Than Five Units Valuation ($)</MenuItem>
        </Select>
      </FormControl>

      {chartData?.length !== 0 && (
        <div className='population-main__text'>{getNoDataText(option)}</div>
      )}
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        renderChart(chartData, apiResponse, state.filters.county, option)
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default Permits;
